<template>
  <div dir="rtl" class="min-h-screen bg-slate-50 lg:flex">
    <SidebarComponent />
    <div class="min-w-0 flex-1">
      <NavbarComponent />
      <main class="px-3 py-5 sm:px-5 lg:px-8">
        <router-view v-slot="{ Component }">
          <Transition name="page" mode="out-in">
            <component :is="Component" />
          </Transition>
        </router-view>
      </main>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import NavbarComponent from '@/components/appComponents/Navbar.vue';
import SidebarComponent from '@/components/appComponents/Sidebar.vue';

export default defineComponent({
  name: "DashboardPage",
  components: { NavbarComponent, SidebarComponent }
})
</script>

<style lang="scss" scoped>
.page-enter-active,
.page-leave-active {
  transition: opacity 150ms ease, transform 150ms ease;
}

.page-enter-from {
  opacity: 0;
  transform: translateY(5px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-3px);
}

@media (prefers-reduced-motion: reduce) {
  .page-enter-active,
  .page-leave-active {
    transition-duration: 1ms;
  }
}
</style>
